import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Award } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    title: 'Plantillas Exclusivas',
    desc: 'Modelos listos para usar.'
  }, {
    title: 'Cartas Profesionales',
    desc: 'Ejemplos de comunicación formal.'
  }, {
    title: 'Checklists de Verificación',
    desc: 'Pasos a seguir organizados.'
  }, {
    title: 'Guía de Organización',
    desc: 'Para ordenar tus finanzas.'
  }, {
    title: 'Glosario Financiero',
    desc: 'Términos explicados de forma simple.'
  }, {
    title: 'Actualizaciones',
    desc: 'Acceso a futuras versiones.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-gradient-to-b from-surface to-[#FFFDF5] relative border-y border-gold/20" data-id="element-67">
      <div className="max-w-5xl mx-auto" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-69">
          <span className="inline-flex items-center gap-2 bg-gold/10 text-gold-dark font-bold px-4 py-1.5 rounded-full text-sm tracking-wide mb-6 border border-gold/20" data-id="element-70">
            <Gift className="w-4 h-4" data-id="element-71" /> +6 BONOS EXCLUSIVOS
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-slate-dark mb-4" data-id="element-72">
            Además recibirás contenido adicional de alto valor
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 mb-16" data-id="element-73">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative overflow-hidden group hover:shadow-md transition-all" data-id="element-74">
              <div className="absolute top-0 right-0 w-16 h-16 bg-gold/5 rounded-bl-full -z-10" data-id="element-75" />
              <div className="w-10 h-10 bg-gold/10 rounded-xl flex items-center justify-center mb-4" data-id="element-76">
                <Gift className="w-5 h-5 text-gold-dark" data-id="element-77" />
              </div>
              <h4 className="text-lg font-bold text-slate-dark mb-2" data-id="element-78">
                {bono.title}
              </h4>
              <p className="text-sm text-slate" data-id="element-79">{bono.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-80">
          <div className="inline-flex items-center gap-3 bg-gold-gradient text-white px-8 py-4 rounded-full shadow-lg shadow-gold-glow" data-id="element-81">
            <Award className="w-6 h-6" data-id="element-82" />
            <span className="font-black tracking-widest uppercase" data-id="element-83">
              VALOR EXTRA INCLUIDO
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}